import { FC, SVGProps } from 'react'

interface CoinIconProps extends SVGProps<SVGSVGElement> {
  size?: number
}

export const CoinIcon: FC<CoinIconProps> = ({ size = 24, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M13.7611 1.00342C18.5161 1.0686 22.0828 5.9655 22.0829 12C22.0829 18.0345 18.6464 22.9944 13.8915 23.0595V23.0639H10.9256V23.0581C6.17421 22.9877 2.20947 18.0313 2.20947 12C2.20952 5.96878 6.04391 1.07382 10.7953 1.00342V1.00049H13.7611V1.00342Z"
        fill="#FFAF47"
      />
      <ellipse cx="11.0977" cy="12.0002" rx="8.8882" ry="11" fill="#F8AF30" />
      <path
        d="M10.7664 6.59452C10.8758 6.36941 11.1966 6.36941 11.306 6.59452L12.623 9.30349C12.6633 9.38647 12.7396 9.44627 12.8298 9.46564L15.5718 10.0544C15.7923 10.1017 15.8837 10.3663 15.7394 10.5397L13.789 12.8822C13.7367 12.945 13.7123 13.0264 13.7214 13.1077L14.0754 16.2572C14.1024 16.4971 13.8494 16.669 13.6364 16.5556L11.1771 15.2468C11.089 15.1999 10.9834 15.1999 10.8953 15.2468L8.43602 16.5556C8.22294 16.669 7.97 16.4971 7.99696 16.2572L8.35099 13.1077C8.36012 13.0264 8.33572 12.945 8.28342 12.8822L6.33303 10.5397C6.18873 10.3663 6.2801 10.1017 6.5006 10.0544L9.24257 9.46564C9.33277 9.44627 9.40905 9.38647 9.44939 9.30349L10.7664 6.59452Z"
        fill="#FFD954"
      />
      <ellipse
        cx="5.87251"
        cy="5.98701"
        rx="1.55849"
        ry="3.6293"
        transform="rotate(33.8474 5.87251 5.98701)"
        fill="white"
      />
    </svg>
  )
}
